import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d441b1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = { class: "login_container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login_header" }, " 로그인 ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "intro",
  src: "/assets/image/login_intro@3x.png"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login_body deep_blue" }, [
  /*#__PURE__*/_createTextVNode(" 엔젤리그의 모든 기능을 사용하고"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 소중한 자산을 안전하게 관리하세요 ")
], -1))
const _hoisted_6 = { class: "form-container" }
const _hoisted_7 = { class: "form-item" }
const _hoisted_8 = { class: "form-item" }
const _hoisted_9 = { class: "form-item" }
const _hoisted_10 = {
  key: 0,
  class: "error-message"
}
const _hoisted_11 = { class: "button-container" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.validBrowser)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                type: "text",
                class: "input-field",
                placeholder: "이름"
              }, null, 512), [
                [_vModelText, _ctx.form.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.phone) = $event)),
                type: "tel",
                class: "input-field",
                placeholder: "010-0000-0000"
              }, null, 512), [
                [_vModelText, _ctx.form.phone]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.birthDate) = $event)),
                type: "date",
                class: "input-field",
                placeholder: "YYYY-MM-DD"
              }, null, 512), [
                [_vModelText, _ctx.form.birthDate]
              ])
            ]),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "block_btn",
              disabled: !_ctx.isFormValid,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.lookupUuid && _ctx.lookupUuid(...args)))
            }, " 로그인 ", 8, _hoisted_12)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}